import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import '../App.css';

function Home() {
  // 1. ഹുക്കുകൾ എല്ലാം ഫംഗ്ഷന്റെ തുടക്കത്തിൽ നൽകുക
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  // App URLs
  const appStoreUrl = "https://apps.apple.com/in/app/mr-white-laundry-booking/id6793832033";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.mrwhiteuae.app";

  // 2. ഫംഗ്ഷനുകൾ
  const scroll = (direction) => {
    const { current } = scrollRef;
    if (direction === 'left') {
      current.scrollBy({ left: -350, behavior: 'smooth' });
    } else {
      current.scrollBy({ left: 350, behavior: 'smooth' });
    }
  };

  const handleServiceClick = () => {
    const savedPhone = localStorage.getItem('userPhone');

    if (auth.currentUser || savedPhone) {
      navigate('/booking');
    } else {
      window.dispatchEvent(new CustomEvent('openAuthModal'));
      return;
    }
  };

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // പ്രൈസിംഗ് വിവരങ്ങൾ (Data Array)
  const pricingData = [
    { 
      id: 1, 
      title: "Wash & Fold", 
      price: "AED 15.00", 
      desc: "Everyday laundry washed, dried, and neatly folded just like home.", 
      img: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=400" 
    },
    { 
      id: 2, 
      title: "Wash & Press", 
      price: "AED 20.00", 
      desc: "Complete care including deep cleaning and professional steam pressing.", 
      img: "https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?q=80&w=400" 
    },
    { 
      id: 3, 
      title: "Steam Press", 
      price: "AED 5.00", 
      desc: "Crisp and wrinkle-free finishing for your already cleaned garments.", 
      img: "https://images.unsplash.com/photo-1489274495757-95c7c837b101?q=80&w=400" 
    },
    { 
      id: 4, 
      title: "Dry Cleaning", 
      price: "AED 35.00", 
      desc: "Premium chemical cleaning for delicate fabrics and high-end fashion.", 
      img: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?q=80&w=400" 
    },
    { 
      id: 5, 
      title: "Shoe Cleaning", 
      price: "AED 38.00", 
      desc: "Deep stain removal and polishing to make your shoes look brand new.", 
      img: "https://images.unsplash.com/photo-1653868249587-284b275a1c67?q=80&w=904&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
    },
    { 
      id: 6, 
      title: "Sofa Cleaning", 
      price: "AED 85.00", 
      desc: "On-site deep extraction cleaning to remove dust, allergens, and stains.", 
      img: "https://images.unsplash.com/photo-1565625443865-2c41cdb647d2?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
    }
  ];

  const faqData = [
    {
      q: "How do I schedule a laundry pickup?",
      a: "You can schedule a pickup through our mobile app or by clicking the 'Schedule a Pickup' button on our website. Simply choose your preferred date and time, and our team will be there."
    },
    {
      q: "What is the typical turnaround time?",
      a: "Our standard turnaround time is 24 hours. We also offer express services if you need your clothes back sooner."
    },
    {
      q: "Do you serve all Emirates in the UAE?",
      a: "Yes, we proudly provide laundry and dry cleaning services across all seven Emirates, including Dubai, Abu Dhabi, and Sharjah."
    },
    {
      q: "How do I pay for the service?",
      a: "We offer multiple payment options including cash on delivery, credit/debit cards through our secure app, and online bank transfers."
    },
    {
      q: "Do you offer eco-friendly cleaning?",
      a: "Absolutely! We use safe, biodegradable cleaning solutions that are tough on stains but gentle on your fabrics and the environment."
    }
  ];

  return (
    <div className="home-container">
      
      {/* Banner */}
      <section className="banner">
        <h1>One Stop<br/>Laundry Solution</h1>
        <p>Fast, reliable laundry, dry cleaning & ironing services across the UAE — pickup & delivery within 24 hours.</p>
        <div className="btn-group">
          <button className="btn btn-book" onClick={handleServiceClick}>
            Schedule a Pickup <i className="fas fa-arrow-right"></i>
          </button>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="btn btn-app" style={{ textDecoration: 'none' }}>
            <i className="fab fa-apple"></i> App Store
          </a>
          <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="btn btn-app" style={{ textDecoration: 'none' }}>
            <i className="fab fa-google-play"></i> Play Store
          </a>
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro">
        <div className="intro-content">
          <h2 style={{fontSize: '2.5rem', margin: '15px 0', color: '#0f172a'}}>Laundry Day Made Simple</h2>
          <p style={{fontSize: '1.1rem', color: '#64748b', lineHeight: '1.8'}}>
            We make laundry effortless. With our mobile app, you can schedule pickups,
             track your orders, and get fresh, clean clothes delivered to your doorstep
              — all in just 24 hours.
          </p>
        </div>
        <div className="intro-image">
          <img src="https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?q=80&w=600" alt="Laundry Service" />
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-container">
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 style={{ fontSize: '3rem', fontWeight: '800', color: '#0f172a' }}>Our Core Values</h2>
          <p style={{ color: '#64748b', fontSize: '1.2rem' }}>Experience the Mr White difference in every wash.</p>
        </div>

        <div className="value-row">
          <div className="value-image">
            <img src="https://images.unsplash.com/photo-1635274605638-d44babc08a4f?w=500" alt="Expert Care" />
          </div>
          <div className="value-content">
            <span>Quality</span>
            <h3>Expert Garment Care</h3>
            <p>At Mr White Laundry, UAE, we provide expert garment care with attention to detail.</p>
          </div>
        </div>

        <div className="value-row">
          <div className="value-image">
            <img src="https://images.unsplash.com/photo-1549037173-e3b717902c57?w=500" alt="Pricing" />
          </div>
          <div className="value-content">
            <span>Affordable</span>
            <h3>Value-For-Money Pricing</h3>
            <p>We focus on delivering high-quality laundry and dry-cleaning services at budget-friendly prices.</p>
          </div>
        </div>

        <div className="value-row">
          <div className="value-image">
            <img src="https://plus.unsplash.com/premium_photo-1682129235687-a4b4168682b7?w=500" alt="Green Cleaning" />
          </div>
          <div className="value-content">
            <span>Eco-Friendly</span>
            <h3>Safe & Green Cleaning</h3>
            <p>We use safe, eco-friendly cleaning solutions that are gentle on your clothes.</p>
          </div>
        </div>

        <div className="value-row">
          <div className="value-image">
            <img src="https://images.unsplash.com/photo-1674471361346-38d423db19f3?q=80&w=870" alt="Quality" />
          </div>
          <div className="value-content">
            <span>In-House</span>
            <h3>In-House Quality Control</h3>
            <p>All garments are processed in our in-house facility to maintain quality control.</p>
          </div>
        </div>

        <div className="value-row">
          <div className="value-image">
            <img src="https://media.istockphoto.com/id/2247859498/photo/dry-cleaning-delivery-service-bringing-fresh-clothes-to-a-happy-customer-at-her-front-door.webp?a=1&b=1&s=612x612&w=0&k=20&c=jyOMcMrlZgaTddi2ulFcLmbYtmMMBXYCy8iCbQ8n-OM=" alt="Delivery" />
          </div>
          <div className="value-content">
            <span>Convenience</span>
            <h3>Easy Pickup & Delivery</h3>
            <p>Book anytime through our app or request a pickup for added convenience.</p>
          </div>
        </div>
      </section>

      {/* Pricing Slider Section with Arrows */}
      <section className="pricing-slider-container">
        <div className="pricing-header">
          <div style={{ textAlign: 'left' }}>
            <h2 className="section-title">Standard Pricing</h2>
            <p className="section-subtitle">Choose from our wide range of services with quality care.</p>
          </div>
          {/* Arrows Navigation */}
          <div className="slider-nav">
            <button className="nav-btn" onClick={() => scroll('left')} aria-label="Previous">
              <i className="fas fa-chevron-left"></i>
            </button>
            <button className="nav-btn" onClick={() => scroll('right')} aria-label="Next">
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div className="slider-wrapper" ref={scrollRef}>
          {pricingData.map((item) => (
            <div
              className="pricing-card-new"
              key={item.id}
              onClick={handleServiceClick}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-img">
                <img src={item.img} alt={item.title} />
              </div>
              <div className="card-details">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <span className="item-price">{item.price}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="uae-service-banner">
        <div className="banner-content">
          <span style={{ color: '#fbd38d', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
            <i className="fas fa-map-marker-alt"></i> Pan UAE Service
          </span>
          <h2>We proudly serve customers across<br/>all Emirates in the UAE.</h2>
          <p>From Dubai to Abu Dhabi, experience premium laundry care delivered to your doorstep within 24 hours.</p>
          
          <div className="emirates-grid">
            <span className="emirate-badge">Dubai</span>
            <span className="emirate-badge">Abu Dhabi</span>
            <span className="emirate-badge">Sharjah</span>
            <span className="emirate-badge">Ajman</span>
            <span className="emirate-badge">Fujairah</span>
            <span className="emirate-badge">Ras Al Khaimah</span>
            <span className="emirate-badge">Umm Al Quwain</span>
          </div>
        </div>

        <div className="banner-action">
          <button className="btn-get-started" onClick={handleServiceClick}>
            Get Started Now <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </section>

      <section className="testimonials-section">
        <div style={{ maxWidth: '700px', margin: '0 auto 60px' }}>
          <span style={{ color: '#2563eb', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px', fontSize: '14px' }}>
            Testimonials
          </span>
          <h2 style={{ fontSize: '2.8rem', fontWeight: '800', color: '#0f172a', marginTop: '10px' }}>
            What Our Customers Say
          </h2>
          <p style={{ color: '#64748b', fontSize: '1.1rem', marginTop: '15px' }}>
            Join thousands of happy customers across the UAE who trust Mr White for their premium laundry needs.
          </p>
        </div>

        <div className="testimonial-grid">
          {/* Testimonial 1 */}
          <div className="testimonial-card">
            <i className="fas fa-quote-right quote-icon"></i>
            <div className="stars">
              <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
            </div>
            <p className="testimonial-text">
              "The best laundry service I've found in Dubai. Their 24-hour delivery is real, and the steam press quality is absolutely professional."
            </p>
            <div className="user-info">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200" alt="Sarah" className="user-img" />
              <div className="user-details">
                <h4>Ahmed Mansoor</h4>
                <span>Business Bay, Dubai</span>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="testimonial-card">
            <i className="fas fa-quote-right quote-icon"></i>
            <div className="stars">
              <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
            </div>
            <p className="testimonial-text">
              "Extremely convenient app experience. I scheduled a pickup for my sofa cleaning, and the team did a fantastic job. Highly recommended!"
            </p>
            <div className="user-info">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200" alt="Fatima" className="user-img" />
              <div className="user-details">
                <h4>Fatima Al Ali</h4>
                <span>Khalidiya, Abu Dhabi</span>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="testimonial-card">
            <i className="fas fa-quote-right quote-icon"></i>
            <div className="stars">
              <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star-half-alt"></i>
            </div>
            <p className="testimonial-text">
              "Mr White is my go-to for Dry Cleaning. They handle delicate fabrics with so much care. The packaging is also very premium."
            </p>
            <div className="user-info">
              <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200" alt="John" className="user-img" />
              <div className="user-details">
                <h4>James Wilson</h4>
                <span>Al Majaz, Sharjah</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="download-app-section">
        <div className="app-content">
          <span>Mobile Experience</span>
          <h2>The Smartest Way<br/>to do Laundry.</h2>
          <p>
            Manage your laundry from anywhere. Schedule pickups, track orders 
            in real-time, and make secure payments—all through the 
            <strong> Mr White </strong> mobile app.
          </p>

          <div className="store-btns">
            {/* App Store */}
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="store-btn">
              <i className="fab fa-apple"></i>
              <div className="btn-text">
                <small>Download on the</small>
                <strong>App Store</strong>
              </div>
            </a>

            {/* Google Play */}
            <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="store-btn">
              <i className="fab fa-google-play"></i>
              <div className="btn-text">
                <small>Get it on</small>
                <strong>Google Play</strong>
              </div>
            </a>
          </div>
        </div>

        <div className="app-image-area">
          <img 
            src="https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=800" 
            alt="Laundry App UI Mockup" 
            className="mockup-img" 
          />
        </div>
      </section>

      <section className="faq-section">
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <span style={{ color: '#2563eb', fontWeight: '700', textTransform: 'uppercase' }}>Got Questions?</span>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0f172a', marginTop: '10px' }}>Frequently Asked Questions</h2>
        </div>

        <div className="faq-container">
          {faqData.map((item, index) => (
            <div className="faq-item" key={index}>
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {item.q}
                <i className={`fas ${activeIndex === index ? 'fa-minus' : 'fa-plus'} faq-icon`}></i>
              </button>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}

export default Home;